import { Component, OnInit, AfterViewInit, HostListener, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DebugService } from '../../services/debug.service';
import { DataIoService } from '../../services/data-io.service';
import { TranslationService } from '../../services/translation.service';
import { MenuService } from '../../services/menu.service';
import { ConfigService } from '../../services/config.service';
import { environment } from '../../../environments/environment'
import { MenuNode } from '../../classes/MenuNode';
import { DeviceDetectorService } from 'ngx-device-detector';
import { CommandBatchService } from 'src/app/services/command-batch.service';

@Component({
    selector: 'app-simulator',
    templateUrl: './simulator.component.html',
    styleUrls: ['./simulator.component.scss']
})
export class SimulatorComponent implements OnInit, AfterViewInit {

    @ViewChild('scriptFile', { static: false }) scriptFile: ElementRef;
    infoText: string;
    _debug: boolean = false;

    _upLoop: any;
    _downLoop: any;
    _loop_interval = 100;
    _loop_offset = 250;

    debug(msg: string): void {
        if (this._debug) {
            console.log("SimulatorComponent: " + msg);
        }
    }

    getTranslator(): TranslationService {
        return this.translator;
    }

    loadScript(event: any) {
        console.log(event);
        let reader: FileReader = new FileReader();
        reader.onloadend = (e) => this.commandBatch.runscript(<string>reader.result);

        reader.readAsText(event.target.files[0]);

    }
    command(): CommandBatchService {
        return this.commandBatch;
    }
    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private debugService: DebugService,
        private ioService: DataIoService,
        private menuService: MenuService,
        private translator: TranslationService,
        private deviceService: DeviceDetectorService,
        private ref: ChangeDetectorRef,
        private commandBatch: CommandBatchService,
        private config: ConfigService
    ) {

        this.debug("Constructor.");
        this._debug = (!environment.production);
    }


    @ViewChild("simulatorWrap", { static: true }) simulatorWrap: ElementRef;
    get fontSize() {
        let bigWidth = 855;
        let elWidth = this.simulatorWrap.nativeElement.offsetWidth;
        //console.log("ElWidth:"+elWidth);
        this.ioService.setWindowWidth(elWidth);
        //42.5 bei 360 müsste 39.5 sein
        return 100.0 * (elWidth / bigWidth) + "%";
    }
    onResize(event) {
        this.ref.markForCheck();

        this.ioService.setWindowWidth(this.simulatorWrap.nativeElement.offsetWidth);
        this.ioService.inputs.resized();
    }
    getWidth() {
        var el = this.simulatorWrap.nativeElement;
        var divWidth = el.offsetWidth
    }
    get opacity() {
        return this.ioService.deviceInfo().getScale('brightness').getCurrentValue() * 100;
    }
    ngOnInit() {
        this.ioService.onInfoTextAvailable().subscribe(
            (element) => {
                this.showInfoTextFor(element);
            },
            (error) => {
                this.debug("Error handling focused element: " + JSON.stringify(error));
            }

        );
    }


    ngAfterViewInit() {
        this.getWidth();
    }

    _caption: string = "";
    formatInfoText(str: string): string {
        if (str) {
            return str.replace(/\n-/g, "\n\n-");
        } else {
            return '';
        }
    }
    removeVars(title: string): string {
        let matches = title.match(/{{[^t^r^:][^{^}]*?}}/g);
        if (matches != null && matches.length > 0) {
            for (let match of matches) {
                title = title.replace(match, '');
            }
        }
        return title;
    }
    extractInfoTitle(element) {

        let rawTitle = element.title;
        // find elements like {{tr:string}}
        let matches = rawTitle.match(/{{tr[^{^}]*?}}/g);
        if (matches != null && matches.length > 0) {
            rawTitle = matches[0];
        }
        if (rawTitle == '{{self.value}}') {
            rawTitle = element.defaultValue;
        }
        rawTitle = this.removeVars(rawTitle);
        rawTitle = rawTitle.replace('{{tr:', '');
        rawTitle = rawTitle.replace('}}', '');
        return rawTitle;
    }
    showInfoTextFor(element: MenuNode) {

        let infoId = element.getInfoTextId();
        if (infoId != "") {
            this.infoText = this.formatInfoText(this.translator.getInfoText(infoId));

        } else if (element.getInfoTexts() !== undefined) {
            let uc = (x: string, i: number) => ((i == 0) ? x.toLocaleUpperCase() : x);
            this.infoText = element.getInfoTexts().map((x, i) => (i != 0 ? "- " : '') + uc(
                this.formatInfoText(this.translator.tr(x)), i)).join('\n\n');
        } else {
            this.infoText = "";
        }
        this._caption = this.extractInfoTitle(element);
        /*
        if(['list','settingsvalue','control-showcase','menu-showcase','help','toast'].includes(element.getTemplate())){
            return;
        }
        if(element.getType() == "menuentry" && !element.hasChild() && infoId == ""){
            return;
        }
        if(element.isDescendantOf('zeitprogrammassistent')){
            return;
        }
        */
    }
    get caption(): string {
        let caption = this.translator.tr(this._caption).replace(':', '');
        caption = caption.replace('{{iconControl}} ', '');
        caption = caption.replace('{{iconInformation}} ', '');
        caption = caption.replace('{{iconConfigurationSettings}} ', '');

        let matches = caption.match(/{{getzone\.[0-9]\.name*?/g);
        if (matches) {
            matches = caption.match(/[0-9]/);
            if (matches) {
                let id = parseInt(matches[0]);
                caption = this.translator.tr('ANCHOR_ZONE_X') + " " + id;
            } else {
                caption = '';
            }
        }

        if (matches) {
            matches = caption.match(/[0-9]/);
            if (matches) {
                let id = parseInt(matches[0]);
                caption = this.translator.tr('ANCHOR_ZONE_X') + " " + id;
            } else {
                caption = '';
            }
        }
        caption = caption.replace(/[0-9]\/[0-9]*/g, '');

        return caption;
    }

    goToSetup($event) {
        $event.preventDefault();
        this.menuService.reset();
        this.router.navigate(['setup']);
    }


    buttonBlinking(btn) {
        return this.menuService.buttonBlinking(btn);
    }


    buttonMuted(btn) {
        return this.menuService.buttonMuted(btn) || this.menuService.isDisabledByView(btn);
    }


    powerClicked() {
        if (this._powerDisabledOnce) {
            this._powerDisabledOnce = false;
            return;
        }

        if (this.menuService.getCurrentNode().getTemplate() == 'control-showcase') {
            this.ioService.powerClicked();
            return;
        }
        console.log("Powerbutton clicked at state " + this.ioService.getDeviceInfo().getValue('powerstate'));
        if (this.ioService.getDeviceInfo().getValue('powerstate') == 'off') {
            this.menuService.goto('idle');
            this.ioService.getDeviceInfo().setValue('powerstate', 'on');
            return;
        }
        if (this.ioService.getDeviceInfo().getValue('powerstate') == 'on') {
            this.ioService.getDeviceInfo().setValue('powerstate', 'going-to-standby');
            this.menuService.goto('standby_animation');
            setTimeout(() => {
                this.ioService.getDeviceInfo().setValue('powerstate', 'off');
                this.menuService.goto('idle');
            }, 2000);
            return;
        }

    }
    whiteQuestionMark(): boolean {
        let nodeId = this.menuService.getCurrentNode().getIdentifier();
        switch (nodeId) {
            case 'wizard_help': {
                return true;
            }
            default: {
                return false;
            }
        }
        return false;
    }
    whiteMenuButton(): boolean {
        let nodeId = this.menuService.getCurrentNode().getIdentifier();
        if (nodeId)
            switch (nodeId) {
                case 'dashboard':
                case 'idle':
                case 'benutzerhandbuch':
                case 'benutzerhandbuch_plain': {
                    return false;
                }
                default: {
                    if (nodeId.startsWith('controlshowcase') || nodeId.startsWith('wizard-controlshowcase')) {
                        return false;
                    }
                }
            }
        return true;
    }
    hasNotButton(btn) {
        return (!!!this.hasButton(btn));
    }

    hasButton(btn) {

        if (btn == 'power') {
            return !this.menuService.isDisabledByView('power');
        }
        let di = this.ioService.getDeviceInfo();
        if (di.getValue('powerstate') == 'off') {
            return false;
        }
        if (di.getValue('powerstate') == 'off' && btn != 'menu') {
            return false;
        }
        if (btn == "scrollbar") {

        }
        if (btn == 'question') {
            return this.menuService.helpAvailable() || this.menuService.buttonEnabled('question');
        }


        if ('dhw' == btn && (!this.config.simulatorConfig.isStandalone())) {
            return false;
        }
        if (['chimney', 'dhw', 'heating'].includes(btn)) {
            if (this.menuService.getCurrentNode().getIdentifier() == 'dashboard') {
                return true;
            }
        }
        return this.menuService.buttonEnabled(btn);
    }

    whiteHeatingButton() {
        return (!this.buttonMuted('heating') && this.ioService.deviceInfo().getRawValue('ai_mode') == 'heating');
    }
    whiteDHWButton() {
        return (!this.buttonMuted('dhw') && this.ioService.deviceInfo().getRawValue('ai_mode') == 'dhw');
    }
    questionClicked() {
        this.ioService.questionClicked();
    }
    backClicked() {
        if (!this.buttonMuted('back')) {
            this.ioService.backClicked();
        }
    }
    chimneyClicked() {

        if (this.buttonMuted('chimney')) {
            return;
        }
        this.ioService.chimneyClicked();
        if (this.menuService.getCurrentNode().getTemplate() != 'control-showcase') {
            this.menuService.goto('chimneysweep');
        }

    }
    dhwClicked() {
        if (this._dhwDisabledOnce) {
            this._dhwDisabledOnce = false;
            return;
        }
        if (this.buttonMuted('dhw')) {
            return;
        }
        this.ioService.deviceInfo().setValue('ai_mode', 'dhw');
        this.ioService.dhwClicked();
    }
    heatingClicked() {
        if (this._heatingDisabledOnce) {
            this._heatingDisabledOnce = false;
            return;
        }
        console.log("heating clicked.");
        if (this.buttonMuted('heating')) {
            return;
        }
        this.ioService.deviceInfo().setValue('ai_mode', 'heating');
        this.ioService.heatingClicked();
    }
    confirmClicked() {
        if (!this.buttonMuted('confirm')) {
            this.ioService.confirmClicked();
        } else {
            this.debug("Confirm muted.");
        }
    }
    isLocked() {
        return this.ioService.getDeviceInfo().getValue('buttonlock') == 'on';
    }
    unlockSequence = false;
    _dhwToggleTimeout: any = null;
    _heatingToggleTimeout: any = null;
    _restartTimeout: any = null;
    _dhwDisabledOnce: boolean = false;
    _heatingDisabledOnce: boolean = false;
    _powerDisabledOnce: boolean = false;

    triggerRestart() {
        console.log("toggle on dhw.");
        this._powerDisabledOnce = true;
        this._restartTimeout = null;
        this.menuService.goto('restart');
    }

    toggleDHW() {
        console.log("toggle on dhw.");
        this._dhwDisabledOnce = true;
        this._dhwToggleTimeout = null;
        let currentMode = this.ioService.deviceInfo().getRawValue('ai_mode_dhw');
        this.ioService.deviceInfo().setValue('ai_mode_dhw', currentMode == 'OFF' ? 'ON' : 'OFF');
        let s = this.ioService.deviceInfo().getScale('__d006');
        if (currentMode === 'OFF') {
            s.restoreValue();
        } else {
            s.saveValue();
            s.setCurrentValue(29.5);
        }
        this.menuService.goto(currentMode == 'OFF' ? 'enableAIDHW' : 'disableAIDHW');
    }

    toggleHeating() {
        console.log("toggle on heating.");
        this._heatingDisabledOnce = true;
        this._heatingToggleTimeout = null;
        let currentMode = this.ioService.deviceInfo().getRawValue('ai_mode_heating');
        this.ioService.deviceInfo().setValue('ai_mode_heating', currentMode == 'OFF' ? 'ON' : 'OFF');
        this.menuService.goto(currentMode == 'OFF' ? 'enableAIHeating' : 'disableAIHeating');
        let s = this.ioService.deviceInfo().getHeatingCircuitById(1).getScale('vorlaufsolltemp');
        if (currentMode === 'OFF') {
            s.restoreValue();
        } else {
            s.saveValue();
            s.setCurrentValue(29);
        }
    }
    aiMode() {
        if (this.menuService.getCurrentNode().getIdentifier() != 'dashboard') {
            return '';
        }
        if (this.ioService.deviceInfo().getRawValue('ai_mode') == 'heating') {
            return 'heating';
        }
        if (this.ioService.deviceInfo().getRawValue('ai_mode') == 'dhw') {
            return 'dhw';
        }
        return '';
    }
    buttonDown(btn) {

        if (btn == 'power') {

            if (this._restartTimeout) {
                clearTimeout(this._restartTimeout);
            }
            this._restartTimeout = setTimeout(
                () => { this.triggerRestart(); },
                3000
            );
            return;
        }

        if (btn == 'dhw') {
            if (this.aiMode() != 'dhw') {
                console.log("not in dhw-mode. aborting.");
                return;
            }
            if (this._dhwToggleTimeout) {
                clearTimeout(this._dhwToggleTimeout);
            }
            this._dhwToggleTimeout = setTimeout(
                () => {
                    this.toggleDHW();
                },
                3000
            );
            return;
        }
        if (btn == 'heating') {
            if (this.aiMode() != 'heating') {
                return;
            }
            console.log("heating down.");
            if (this._heatingToggleTimeout) {
                clearTimeout(this._heatingToggleTimeout);
            }
            this._heatingToggleTimeout = setTimeout(
                () => { this.toggleHeating(); },
                3000
            );
            return;
        }
        if (btn === 'menu' && this.isLocked()) {
            this.unlockSequence = true;
            this.menuService.goto('unlocksequence');
        }
    }
    buttonUp(btn) {
        if (btn === 'menu' && this.isLocked()) {
            console.log("going to idle.");
            this.menuService.goto('idle');
        }

        if (btn == 'power' && this._restartTimeout != null) {
            clearTimeout(this._restartTimeout);
            this._restartTimeout = null;
            return;
        }
        if (btn == 'heating' && this._heatingToggleTimeout != null) {
            console.log("heating up.");
            clearTimeout(this._heatingToggleTimeout);
            this._heatingToggleTimeout = null;
            return;
        }
        if (btn == 'dhw' && this._dhwToggleTimeout != null) {
            clearTimeout(this._dhwToggleTimeout);
            this._dhwToggleTimeout = null;
            return;
        }
    }
    menuClicked() {
        if (this.isLocked()) {
            return;
        }
        if (this.unlockSequence) {
            this.unlockSequence = false;
            return;
        }
        if (!this.buttonMuted('menu')) {
            if (this.hasButton('menu')) {
                this.ioService.menuClicked();
            }
        }
    }


    menuUpClicked() {
        if (this.buttonMuted('up')) {
            return;
        }
        this.debug("UpClicked");
        if (this.clickEnabled) {
            this.ioService.upClicked();
        }

    }



    menuDownClicked() {
        if (this.buttonMuted('down')) {
            return;
        }
        this.debug("DownClicked");
        if (this.clickEnabled) {
            this.ioService.downClicked();
        }


    }


    onPan($event) {

        this._downPressed = false;
        this._upPressed = false;
    }

    _panning = false;


    onPanStart($event) {
        this._panning = true;
        this.ioService.panStart();
        this._downPressed = false;
        this._upPressed = false;
    }

    clickEnabled = true;
    disableClick() {
        this.clickEnabled = false;
    }
    enableClick() {
        this.clickEnabled = true;
    }
    onPanEnd($event) {
        $event.preventDefault();
        setTimeout(() => {
            this.enableClick();
        }, 50);
        this._panning = false;
        this.ioService.panEnd();
        this._downPressed = false;
        this._upPressed = false;
    }


    onPanMove($event) {

    }


    onPanUp($event) {
        $event.preventDefault();
        this.disableClick();
        this._downPressed = false;
        this._upPressed = false;

        if (this.buttonMuted('up') && this.buttonMuted('slider')) {
            return;
        }
        if (this._panning) {
            this.ioService.panUp();
        }

    }


    pans = 0;
    skips = 6;


    onPanDown($event) {
        this.disableClick();
        this._downPressed = false;

        this._upPressed = false;
        if (this.buttonMuted('down') && this.buttonMuted('slider')) {
            return;
        }

        //this.pans = (++this.pans % this.skips);
        if (this._panning) {
            this.ioService.panDown();
        }

    }
    _panDownTimeout = null;
    downPressed($event) {

        $event.preventDefault();
        this._upPressed = false;
        this._downPressed = true;
        this.cancelPanDown();
        this._panDownTimeout = setTimeout(
            () => {
                if (this._downPressed && !this._panning) {
                    this._downLoop = setInterval(
                        () => {
                            if (!this._downPressed || this._panning) {
                                clearInterval(this._downLoop);
                                return;
                            } else {
                                console.log("pandown-step.");
                                this.menuDownClicked();
                            }
                        },
                        this._loop_interval);
                }
            },
            this._loop_offset);
    }

    cancelPanDown(dontCancelUp?: boolean) {
        if (dontCancelUp !== true) {
            this.cancelPanUp(true);
        }
        if (this._panDownTimeout) {
            clearTimeout(this._panDownTimeout);
            this._panDownTimeout = undefined;
        }
    }

    cancelPanUp(dontCancelDown?: boolean) {
        if (dontCancelDown !== true) {
            this.cancelPanDown(true);
        }
        if (this._panUpTimeout) {
            clearTimeout(this._panUpTimeout);
            this._panUpTimeout = undefined;
        }
    }
    downReleased($event) {
        this._downPressed = false;
        this._upPressed = false;
        this.cancelPanDown();
    }

    _panUpTimeout = undefined;
    upPressed($event) {

        $event.preventDefault();
        this._downPressed = false;
        this._upPressed = true;
        this.cancelPanUp();
        this._panUpTimeout = setTimeout(
            () => {
                if (this._upPressed && !this._panning) {
                    this._upLoop = setInterval(
                        () => {
                            if (!this._upPressed || this._panning) {
                                clearInterval(this._upLoop);
                                return;
                            } else {

                                this.menuUpClicked();
                            }
                        },
                        this._loop_interval);
                }
            },
            this._loop_offset);
    }


    upReleased($event) {
        //console.log("Up released.");
        this._upPressed = false;
        this._downPressed = false;
        this.cancelPanUp();
    }
    _downPressed = false;
    _upPressed = false;

    @HostListener('window:keydown', ['$event'])
    keyEvent(ke: KeyboardEvent) {
        switch (ke.keyCode) {
            case 68: {//d
                ke.stopPropagation();
                this.menuService.goto('diag_overview');
                return false;
            }
            case 70: { // f;
                ke.stopPropagation();
                this.menuService.goto('fachhandwerkerebene');
                return false;
            }
            case 13: { // 
                this.confirmClicked();
                ke.stopPropagation();
                ke.stopImmediatePropagation();
                return false;
            }
            case 37: {
                this.backClicked();
                ke.stopPropagation();
                ke.stopImmediatePropagation();
                return false;
            }
            case 38: {
                this.menuUpClicked();
                ke.stopPropagation();
                ke.stopImmediatePropagation();
                return false;
            }
            case 39: {
                this.menuClicked();
                ke.stopPropagation();
                ke.stopImmediatePropagation();
                return false;
            }
            case 40: {
                this.menuDownClicked();
                ke.stopPropagation();
                ke.stopImmediatePropagation();
                return false;
            }

            case 83: {
                console.log("s clicked.");
                this.scriptFile?.nativeElement?.click();
                ke.stopPropagation();
                ke.stopImmediatePropagation();
                return false;
            }
        }
        console.log("Key Pressed: " + ke.keyCode);
        this.debug("Key Down: " + ke.keyCode);
    }



}